<div class="container">
    <div class="header">
        <div>
            <img style="width: 55px;" src="assets/plateformebeneficiaire/images/logo.png" alt="Logo" />
        </div>
        <h1 class="h1-pacifico">Orca</h1>
    </div>

    <!-- Bloc gauche -->
    <section class="card">
        <h2 class="hero-title">Facilitez vos échanges avec votre assistant·e de service social du travail</h2>
        <p class="hero-desc">
            Besoin d'être accompagné·e par un·e assistant·e de service social du travail ? Rien de plus facile avec Orca
            !
        </p>

        <div class="features">
            <div class="feature">
                <div class="ico">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="5" width="18" height="16" rx="2" stroke="#6A4AE3" stroke-width="1.6" />
                        <path d="M16 3v4M8 3v4" stroke="#6A4AE3" stroke-width="1.6" stroke-linecap="round" />
                    </svg>
                </div>
                <div style="padding-top: 12px">
                    <strong>Prenez rendez-vous en quelques clics</strong>
                </div>
            </div>

            <div class="feature">
                <div class="ico">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                        <path d="M9 11l2 2 4-4" stroke="#3BB78F" stroke-width="1.6" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <rect x="3" y="4" width="18" height="16" rx="2" stroke="#3BB78F" stroke-width="1.2" />
                    </svg>
                </div>
                <div style="padding-top: 12px">
                    <strong>Retrouvez vos conseils et les actions de votre assistant·e</strong>
                </div>
            </div>

            <div class="feature">
                <div class="ico">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#17A2B8"
                            stroke-width="1.4" />
                        <path d="M14 2v6h6" stroke="#17A2B8" stroke-width="1.4" />
                    </svg>
                </div>
                <div style="padding-top: 12px">
                    <strong>Échangez vos documents en toute sécurité</strong>
                </div>
            </div>

            <div class="feature">
                <div class="ico">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                        <path d="M3 7h18M7 11h10M7 15h6" stroke="#FFC253" stroke-width="1.6" stroke-linecap="round" />
                        <rect x="3" y="3" width="18" height="18" rx="3" stroke="#FFC253" stroke-width="1.2" />
                    </svg>
                </div>
                <div style="padding-top: 12px">
                    <strong>Restez informé·e des dernières actualités sociales</strong>
                </div>
            </div>
        </div>

        <div style="margin-top:32px;text-align:right;">
            <button class="btn-login" (click)="goToApp()" style="font-size:16px;padding:14px 28px;">
                Commençons
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M10 17l5-5-5-5v10z" fill="white" />
                </svg>
            </button>
        </div>
    </section>

    <!-- Bloc connexion -->
    <aside class="card login-card" #loginSection>
        <div class="illustration">
            <svg viewBox="0 0 120 100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="60" cy="50" r="45" fill="#f3f0ff" />
                <rect x="45" y="35" width="30" height="25" rx="4" fill="#6A4AE3" opacity="0.9" />
                <path d="M60 25a8 8 0 0 1 8 8v2h-16v-2a8 8 0 0 1 8-8z" fill="#9C6BFF" />
                <circle cx="60" cy="48" r="3" fill="#fff" />
            </svg>
        </div>
        <h3>Bienvenue sur votre espace bénéficiaire</h3>
        <p>Accédez à votre espace sécurisé en vous connectant ci-dessous.</p>
        <button class="btn-login" (click)="goToApp()">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                <path d="M10 17l5-5-5-5v10z" fill="white" />
            </svg>
            Accéder à mon espace
        </button>
    </aside>

    <!-- Section mobile -->
    <div class="promo">
        <div class="promo-content">
            <div>
                <img src="assets/plateformebeneficiaire/images/screen_iphone_homepage_noshadow.png"
                    alt="Orca sur mobile"
                    style="width: 200px; height: 220px; object-fit: cover; object-position: top;" />
            </div>
            <div>
                <h4 style="margin:0 0 6px;font-size:25px">Profitez des avantages Orca en version mobile</h4>
                <p style="margin:0;color:#6b7280;">Disponible sur l'App Store et Google Play.</p>
                <div
                    style="margin-top:16px;display:flex;align-items:center;gap:8px;color:#6A4AE3;font-weight:600;font-size:16px;">
                    Téléchargez maintenant l'application "Orca"
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style="transform:rotate(45deg);">
                        <path d="M7 17l9.2-9.2M17 17V7h-10" stroke="#6A4AE3" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
        <div style="display:flex;gap:20px;padding-right: 3em;">
            <div style="display:flex;gap:20px;padding-right: 3em;">
                <div style="text-align:center;">
                    <div class="qr"><img src="assets/plateformebeneficiaire/images/qr-code.png" alt="QR Code App Store"
                            style="width:100%;border-radius:12px"></div>
                    <div style="margin-top:8px;font-size:14px;font-weight:600;color:#6b7280;">Apple</div>
                </div>
                <div style="text-align:center;">
                    <div class="qr"><img src="assets/plateformebeneficiaire/images/qr-code.png" alt="QR Code Google Play"
                            style="width:100%;border-radius:12px"></div>
                    <div style="margin-top:8px;font-size:14px;font-weight:600;color:#6b7280;">Android</div>
                </div>
            </div>
        </div>
    </div>
</div>

<footer>Orca — interface optimisée pour grand écran et SSO.</footer>